import { Column } from '@components/LinearLayout';
import { PSmallBold } from '@components/Typography';
import styled from 'styled-components';

export const FormItemRoot = styled(Column)<{
  $width?: string;
  $isLocked?: boolean;
  $gap?: string;
}>`
  position: relative;
  width: ${({ $width }) => $width};
  height: 100%;

  justify-content: space-between;
  gap: ${({ $gap }) => $gap};

  opacity: ${({ $isLocked }) => ($isLocked ? 0.5 : 1)};
  point-event: ${({ $isLocked }) => ($isLocked ? 'none' : 'inherit')};
  pointer: ${({ $isLocked }) => ($isLocked ? 'none' : 'inherit')};

  #react-select-3-placeholder {
    padding-top: 0.6rem;
  }
`;

export const FormItemLabel = styled(PSmallBold)<{
  $required?: boolean;
  $isCentered?: boolean;
  $paddingLabel?: string;
  $labelColor?: string;
  $isSmallForm?: boolean;
  $labelFontSize?: string;
}>`
  display: block;
  padding: ${({ $paddingLabel }) => $paddingLabel};
  color: ${({ $labelColor }) => $labelColor};
  font-size: ${({ $labelFontSize, theme }) =>
    $labelFontSize || theme.fontSize.size15};
  font-weight: ${({ theme, $isSmallForm }) =>
    $isSmallForm ? '800' : theme.fontWeight.weight900};
  line-height: ${({ theme, $isSmallForm }) =>
    $isSmallForm ? theme.lineHeight.height140 : theme.lineHeight.height150};
  margin: ${({ $isCentered }) => $isCentered && 'auto'};
  &::after {
    content: '${({ $required }) => ($required ? '*' : '')}';
  }
`;

export const FormItemChildren = styled.div<{
  isLocked?: boolean;
}>`
  cursor: ${props => props.isLocked && 'not-allowed'};
`;

export const ErrorText = styled(PSmallBold)`
  color: ${({ theme }) => theme.color.error};
  font-size: ${({ theme }) => theme.fontSize.size14};
  font-weight: ${({ theme }) => theme.fontWeight.weight500};
  padding-left: 1rem;
  line-height: ${({ theme }) => theme.lineHeight.height140};
`;
